<div *ngIf="progress" class="mt-3">
    <p *ngIf="progress" style="color: black;">{{filename}}</p>
    <div class="progress" *ngIf="progress" style="margin-top: 10px; margin-bottom: -20px;">
        <div class="progress-bar" [style.width]="progress + '%'">{{progress}}%</div>
    </div>
</div>